/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tXkSR39sgCDWSitZxC5xFV
// Component: 5TapYEMkYCfR

import * as React from "react";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import IconButton from "../../components/widgets/IconButton"; // plasmic-import: LPry-TF4j22a/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_design_system.css"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/projectcss
import sty from "./PlasmicDialogHeader.module.css"; // plasmic-import: 5TapYEMkYCfR/css

import CloseIcon from "../plasmic_kit/PlasmicIcon__Close"; // plasmic-import: hy7vKrgdAZwW4/icon
import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon

createPlasmicElementProxy;

export type PlasmicDialogHeader__VariantMembers = {
  grabbable: "grabbable";
};
export type PlasmicDialogHeader__VariantsArgs = {
  grabbable?: SingleBooleanChoiceArg<"grabbable">;
};
type VariantPropType = keyof PlasmicDialogHeader__VariantsArgs;
export const PlasmicDialogHeader__VariantProps = new Array<VariantPropType>(
  "grabbable"
);

export type PlasmicDialogHeader__ArgsType = {
  heading?: React.ReactNode;
  subheading?: React.ReactNode;
  actions?: React.ReactNode;
};
type ArgPropType = keyof PlasmicDialogHeader__ArgsType;
export const PlasmicDialogHeader__ArgProps = new Array<ArgPropType>(
  "heading",
  "subheading",
  "actions"
);

export type PlasmicDialogHeader__OverridesType = {
  root?: Flex__<"div">;
  freeBox?: Flex__<"div">;
};

export interface DefaultDialogHeaderProps {
  heading?: React.ReactNode;
  subheading?: React.ReactNode;
  actions?: React.ReactNode;
  grabbable?: SingleBooleanChoiceArg<"grabbable">;
  className?: string;
}

const $$ = {};

function PlasmicDialogHeader__RenderFunc(props: {
  variants: PlasmicDialogHeader__VariantsArgs;
  args: PlasmicDialogHeader__ArgsType;
  overrides: PlasmicDialogHeader__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "grabbable",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.grabbable
      }
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_tXkSR39sgCDWSitZxC5xFV",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        { [sty.rootgrabbable]: hasVariant($state, "grabbable", "grabbable") }
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}

        className={classNames("all", sty.freeBox)}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <div className={classNames("all", "__wab_text", sty.text__cwRb6)}>
              {"Heading"}
            </div>
          ),
          value: args.heading,
          className: classNames(sty.slotTargetHeading)
        })}
        {renderPlasmicSlot({
          defaultContents: (
            <div className={classNames("all", "__wab_text", sty.text__piCgy)}>
              {
                "Subheading that is really really really really really really long"
              }
            </div>
          ),
          value: args.subheading,
          className: classNames(sty.slotTargetSubheading)
        })}
      </div>
      {renderPlasmicSlot({
        defaultContents: (
          <IconButton
            children2={
              <ChevronDownSvgIcon
                className={classNames("all", sty.svg__xhmv)}
                role={"img"}
              />
            }
            className={classNames("__wab_instance", sty.iconButton__kZb4U)}
            withBackgroundHover={true}
          >
            <CloseIcon
              className={classNames("all", sty.svg__devKg)}
              role={"img"}
            />
          </IconButton>
        ),
        value: args.actions
      })}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox"],
  freeBox: ["freeBox"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicDialogHeader__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicDialogHeader__VariantsArgs;
    args?: PlasmicDialogHeader__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicDialogHeader__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicDialogHeader__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDialogHeader__ArgProps,
          internalVariantPropNames: PlasmicDialogHeader__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDialogHeader__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDialogHeader";
  } else {
    func.displayName = `PlasmicDialogHeader.${nodeName}`;
  }
  return func;
}

export const PlasmicDialogHeader = Object.assign(
  // Top-level PlasmicDialogHeader renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicDialogHeader
    internalVariantProps: PlasmicDialogHeader__VariantProps,
    internalArgProps: PlasmicDialogHeader__ArgProps
  }
);

export default PlasmicDialogHeader;
/* prettier-ignore-end */
